import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DavidSinclairPage from './pages/DavidSinclairPage';
import DanielAmenPage from './pages/DanielAmenPage';
import DianaPalotasPage from './pages/DianaPalotasPage';
import NiculinaPsihologPage from './pages/NiculinaPsihologPage';
import MatthewWalkerPage from './pages/MatthewWalkerPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import GDPRPage from './pages/GDPRPage';
import SpeakersWidget from './components/SpeakersWidget';
import CookiePopup from './components/CookiePopup';
import { SPONSOR_FORM_URL } from './config';

function RedirectToSponsorApp() {
  useEffect(() => {
    window.location.replace(SPONSOR_FORM_URL);
  }, []);
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>Redirecționare către formularul de sponsorizare...</div>
  );
}

function App() {
  const location = useLocation();
  const scriptsLoaded = useRef({
    script: false,
    formEmbed: false
  });

  useEffect(() => {
    // Scroll to top on page change
    window.scrollTo(0, 0);
    
    // Facebook Pixel tracking
    // Wait for Pixel to be ready, or use queue if not loaded yet
    const trackPixel = () => {
      if (typeof window.fbq !== 'undefined') {
        if (location.pathname === '/') {
          window.fbq('track', 'PageView');
        }
      } else {
        // If Pixel not loaded yet, wait a bit and retry
        setTimeout(trackPixel, 100);
      }
    };
    
    trackPixel();

    // Load script.js only once
    if (!scriptsLoaded.current.script && !document.querySelector('script[src="/script.js"]')) {
      const script1 = document.createElement('script');
      script1.src = '/script.js';
      script1.defer = true;
      script1.id = 'main-script';
      document.body.appendChild(script1);
      scriptsLoaded.current.script = true;
    }

    // Form embed script no longer loaded here — sponsor form lives in brain-event-sponsorship app
  }, [location]);

  // Hide speakers widget on form, thank you, and speaker pages
  const showSpeakersWidget = location.pathname === '/';

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/david-sinclair" element={<DavidSinclairPage />} />
        <Route path="/daniel-amen" element={<DanielAmenPage />} />
        <Route path="/diana-palotas" element={<DianaPalotasPage />} />
        <Route path="/niculina-gheorghita" element={<NiculinaPsihologPage />} />
        <Route path="/matthew-walker" element={<MatthewWalkerPage />} />
        <Route path="/devino-sponsor" element={<RedirectToSponsorApp />} />
        <Route path="/termeni-si-conditii" element={<TermsPage />} />
        <Route path="/politica-de-confidentialitate" element={<PrivacyPage />} />
        <Route path="/politica-cookies" element={<CookiesPage />} />
        <Route path="/gdpr" element={<GDPRPage />} />
      </Routes>
      {showSpeakersWidget && <SpeakersWidget />}
      <CookiePopup />
    </>
  );
}

export default App;

